import React, { useContext, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Fab from '@material-ui/core/Fab';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import ChallengeContext from '../../../context/challenge-context'
import { BreadcrumbsCustom, Buttons } from '../../shared/component'
import useStyles from '../../../styles/components/learningcontent/stylesLearningContents'
import EditTeamMemberDialog from './teamMember/EditTeamMemberDialog';
import ViewActivityHistory from './teamMember/ViewActivityHistory';
import { Claims } from '../../../utils/services/cache/ClientCache'

const TeamMember = () => {

    const classes = useStyles();
    const { challengeContext, dispatch } = useContext(ChallengeContext);
    const [editTeamMember, setEditTeamMember] = useState({ open: false, studentNumber: '', memberId: 0 })
    const [activityHistory, setActivityHistory] = useState({ open: false, studentNumber: '', memberId: 0 })

    const breadcrumbsData = [
        {
            text: 'Challenge',
            href: '/Challenge'
        },
        {
            text: 'Team Members',
            href: ''
        },
    ];

    const handleEdit = async (member) => {
        let data = {
            open: true,
            studentNumber: member.StudentNumber,
            memberId: member.MemberId,
        }
        setEditTeamMember(data);
    }

    const handleViewHistory = async (member) => {
        let data = {
            open: true,
            studentNumber: member.StudentNumber,
            memberId: member.MemberId,
        }
        setActivityHistory(data);
    }

    const handleClose = () => {
        setEditTeamMember({ open: false, studentNumber: '', memberId: 0 })
    }

    const handleCloseHistory = () => {
        setActivityHistory({ open: false, studentNumber: '', memberId: 0 })
    }

    const signUpDialogOpen = () => {
        challengeContext.signUpForm.challengeId = challengeContext.challenge.ChallengeId;
        challengeContext.signUpForm.teamMembers[0].studentNumber = Claims.getGivenName();
        challengeContext.signUpForm.teamMembers[0].isLeader = true;
        dispatch({ type: 'SET_SIGNUPFORM', signUpForm: challengeContext.signUpForm });

        challengeContext.dialogs.signUpDialog = true;
        dispatch({ type: 'SET_DIALOGS', dialogs: challengeContext.dialogs });
    }

    const handleClickTabs = (item) => {
        switch (item) {
            case "overview":
                challengeContext.tabs.overview = true;
                challengeContext.tabs.teamMember = false;
                challengeContext.tabs.activities = false;
                challengeContext.tabs.leaderboard = false;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
        }
    }

    return (
        <>
            <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
            {
                challengeContext.challenge.TeamMemberViewModels.length > 0 ?
                    <>
                        <Grid classes={{ root: classes.rootGridDescription }}>
                            <Typography style={{ fontSize: '20px', fontWeight: 'bold' }}>Team Name : {challengeContext.challenge.TeamName}</Typography>
                        </Grid>
                        <TableContainer component={Paper} style={{ marginBottom: '50px' }}>
                            <Table>
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#0C8FAD' }}>
                                        <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Student Number</TableCell>
                                        <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Status</TableCell>
                                        <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Activity History</TableCell>
                                        {
                                            Claims.getGivenName() === challengeContext.challenge.SignUpBy ?
                                                <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Edit</TableCell>
                                                : <></>
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {challengeContext.challenge.TeamMemberViewModels.map((row) => (
                                        <TableRow key={row.StudentNumber}>
                                            <TableCell align="center">
                                                {row.StudentNumber}
                                            </TableCell>
                                            <TableCell align="center" style={{ color: '#4486a3' }}>{row.Status}</TableCell>
                                            <TableCell align="center"><Buttons text="View" onClick={() => handleViewHistory(row)} /></TableCell>
                                            {
                                                Claims.getGivenName() === challengeContext.challenge.SignUpBy && !challengeContext.challenge.IsEnded ?
                                                    <TableCell align="center">
                                                        {
                                                            row.Status === "Pending"
                                                                && row.StudentNumber !== challengeContext.challenge.SignUpBy ?
                                                                <Buttons text="Edit" onClick={() => handleEdit(row)} />
                                                                : <></>
                                                        }
                                                    </TableCell>
                                                    : <></>
                                            }
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                    :
                    challengeContext.challenge.IsEnded ?
                        <></>
                        :
                        <Alert icon={false} variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                            You do not have a team for this challenge. Click <a className="button one" onClick={() => signUpDialogOpen()}>Here</a> to participate in this challenge.
                        </Alert>
            }
            {
                editTeamMember.open ?
                    <EditTeamMemberDialog _handleClose={handleClose} _studentNumber={editTeamMember.studentNumber} _memberId={editTeamMember.memberId} />
                    : <></>
            }
            {
                activityHistory.open ?
                    <ViewActivityHistory _handleClose={handleCloseHistory} _studentNumber={activityHistory.studentNumber} _memberId={activityHistory.memberId} />
                    : <></>
            }
            <Hidden lgUp>
                <Fab onClick={() => handleClickTabs("overview")} color="secondary" style={{ position: "fixed", bottom: '5px', right: '5px', margin: '5px' }}>
                    <ArrowBackIcon />
                </Fab>
            </Hidden>
        </>
    );
};

export default TeamMember;